import React, { useContext, useEffect, useState, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import { Navigate, useLocation } from "react-router-dom";
import AIAssistantSidebar from "../components/AIAssistant/AIAssistantSidebar";
import Content from "../components/Content";
import Notification from "../components/Notification";
import { ProductContext } from "../store";
import Cookies from 'js-cookie';
import { PostData } from "../services/FetchData";

const AIAssistant = () => {
	const [isLogged, setIsLogged] = useState(true),
		mainContent = React.useRef(null),
		location = useLocation(),
		{
			setUserData,
			setUserLoader,
			setWebsiteLoader,
			setWebsiteData,
			setCurrentWebsiteId,
			setUserWebsitePlan,
			setProductTypes,
			loadVisualEditor,
			productTypes,
			userLoader
		} = useContext(ProductContext);

	useEffect(() => {
		document.documentElement.scrollTop = 0
		document.scrollingElement.scrollTop = 0
		if (mainContent.current) {
			mainContent.current.scrollTop = 0
		}
	}, [location]);

	const getUserDetail = useCallback(() => {
		setUserLoader(true)
		setWebsiteLoader(true)
		PostData("ms1", "api/v1/user/getUserDetail").then(result => {
			if (result !== "Invalid" && result !== undefined) {
				if (result.status === "success") {
					setUserData(result.data.user)
					let websiteId = Cookies.get("_website_id")
					if (result.data.websites && Array.isArray(result.data.websites) && result.data.websites.length > 0) {
						if (!Cookies.get("_website_id")) {
							Cookies.set('_website_id', result.data.websites[0].websiteId)
							websiteId = result.data.websites[0].websiteId
							setCurrentWebsiteId(result.data.websites[0].websiteId)							
						}else{
							setCurrentWebsiteId(Cookies.get("_website_id"))
						}
						let websitesLocal = result.data.websites,
							websiteDataLocal = {}
						for (let i = 0; i < websitesLocal.length; i++) {
							let currentWebsite = websitesLocal[i]
							websiteDataLocal[currentWebsite.websiteId] = currentWebsite
						}
						setUserWebsitePlan(websiteDataLocal[websiteId].websiteUserPlan)
						// Extract productTypes from productsMapping
						const productsMapping = websiteDataLocal[websiteId].productsMapping || []
						setProductTypes(productsMapping)
						setWebsiteData(websiteDataLocal)
					}

				}
			}
			setWebsiteLoader(false)
			setUserLoader(false)
		});
	}, [setUserData, setUserLoader, setWebsiteLoader, setWebsiteData, setCurrentWebsiteId, setUserWebsitePlan, setProductTypes]);

	useEffect(() => {
		const Token = Cookies.get("_cb_search_token");
		if (!Token) {
			setIsLogged(false);
		} else {
			getUserDetail()
		}
	}, [getUserDetail])

	if (!isLogged) {
		return <Navigate to="/auth/login" replace />
	}

	// Redirect if user doesn't have aiassistant product type (only after data is loaded)
	if (!userLoader && productTypes !== undefined && productTypes !== null && !productTypes.includes("aiassistant")) {
		return <Navigate to="/user/dashboard" replace />
	}

	return (
		<>
			<section className="applicationWrapper" ref={mainContent}>
				<div className="applicationContentWrap">
					<Sidebar />
					{!loadVisualEditor &&
						<AIAssistantSidebar />
					}
					<Content type="aiassistant" />
				</div>
				<Notification />
			</section>
		</>
	);
};

export default AIAssistant;
